/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum NotifyMeType {
  _0 = 0,
  _1 = 1
}
